import { useEffect, useMemo, useState } from "react";
import { http } from "../../lib/api";
import { fValor } from "../../lib/trading";
import { TC, TvChart } from "./TvChart";
import { TradingPanel, agregar, cambioRango, recortar, tonoDe } from "./Panel";

const M = (v) => fValor(v, "money");
const P2 = (v) => `${(v * 100).toFixed(2)}%`;
const num = (v) => Number(String(v ?? 0).replace(/[^0-9.-]/g, "")) || 0;

// Portfolio Explorer: saldo e IMOR diarios del slice seleccionado (reconstrucción de Loan Management).
export const SliceSeries = ({ ds, ids, corte }) => {
  const [s, setS] = useState(null);
  const [r, setR] = useState(0);
  const [iv, setIv] = useState("S");
  const key = ids.join("|");
  useEffect(() => {
    if (!ids.length) { setS([]); return undefined; }
    const t = setTimeout(() => http.post("/ticker/serie-slice", { dataset: ds, ids }).then((x) => setS(x.data)).catch(() => setS([])), 300);
    return () => clearTimeout(t);
  }, [ds, key]); // eslint-disable-line react-hooks/exhaustive-deps
  const sal = useMemo(() => recortar((s || []).map((p) => ({ fecha: p.fecha, valor: p.saldo })), r), [s, r]);
  if (!s) return <div className="trd h-[300px] animate-pulse rounded-2xl" data-testid="exp-serie-cargando" />;
  if (!s.length) return null;
  const lim = sal[0]?.fecha || "";
  const imor = s.filter((p) => p.fecha >= lim).map((p) => ({ fecha: p.fecha, valor: p.vencida }));
  const c = cambioRango(sal, (d, a) => (a ? `${d > 0 ? "+" : ""}${((d / a) * 100).toFixed(2)}%` : ""));
  return (
    <TradingPanel title={`Saldo e IMOR del slice · ${ids.length} créditos`} ultimo={sal.length ? fValor(sal[sal.length - 1].valor, "money", true) : "—"} cambio={c.txt} tono={tonoDe(c.dir, "up_good")}
      rango={r} setRango={setR} iv={iv} setIv={setIv} corte={corte} testid="exp-serie"
      como="Saldo diario del slice reconstruido con el cálculo de Loan Management; IMOR = saldo con 90+ días de atraso ÷ saldo del slice (eje izquierdo)." fuente="Loan Management · /api/ticker/serie-slice">
      <TvChart height={280} fmt={M} testid="exp-serie-chart"
        series={[{ id: "saldo", name: "Saldo", type: "area", color: TC.up, data: agregar(sal, iv), fmt: M }, { id: "imor", name: "IMOR", type: "line", color: TC.down, scale: "left", data: agregar(imor, iv), fmt: P2 }]} />
    </TradingPanel>
  );
};

// Concentración del slice por acreditado (profundidad acumulada).
export const Concentracion = ({ creditos }) => {
  const g = {};
  creditos.forEach((r) => { const k = r["Razón social / nombre"] || r["Loan ID"]; g[k] = (g[k] || 0) + num(r["Saldo insoluto"]); });
  const tot = Object.values(g).reduce((a, b) => a + b, 0) || 1;
  const top = Object.entries(g).sort((a, b) => b[1] - a[1]).slice(0, 10);
  let acc = 0;
  return (
    <TradingPanel title="Concentración por acreditado" ultimo={P2(top.slice(0, 5).reduce((a, [, v]) => a + v, 0) / tot)} cambio="top 5" tono="flat" testid="exp-concentracion"
      como="Saldo de cada acreditado ÷ saldo del slice (barra) y acumulado (sombra). El encabezado muestra la concentración de los 5 mayores." fuente="Loan Management · tape">
      <div className="space-y-1">{top.map(([k, v], i) => {
        acc += v;
        return (
          <div key={k} className="relative grid grid-cols-12 items-center gap-2 overflow-hidden rounded-md px-2 py-1 text-[11px]" data-testid={`conc-${i}`}>
            <div className="absolute inset-y-0 left-0 bg-[var(--trd-accent)]/10" style={{ width: `${(acc / tot) * 100}%` }} />
            <div className="absolute inset-y-1 left-0 rounded-r bg-[var(--trd-accent)]/40" style={{ width: `${(v / tot) * 100}%` }} />
            <span className="relative col-span-7 truncate text-[#C9D1D9]">{k}</span>
            <span className="trd-mono relative col-span-3 text-right">{fValor(v, "money")}</span>
            <span className="trd-mono relative col-span-2 text-right text-[var(--trd-muted)]">{P2(v / tot)}</span>
          </div>);
      })}</div>
    </TradingPanel>
  );
};
